<!-- <div class="disable-parameter-changes-container"> -->
  <!-- Основная строка с иконкой, текстом и toggle -->
  <div class="disable-parameter-changes-header">
    <app-item-icon
      icon="settings"
      appearance="blue"
    ></app-item-icon>

    <h2 class="disable-parameter-changes-title dangerous-item" >Запретить изменение параметров через ДБО</h2>

    <ion-toggle
      mode="ios"
      [checked]="isEnabled"
      [disabled]="isEnabled"
      (ionChange)="onToggleChange($any($event))"
      data-testid="disable-parameter-changes-toggle"
    ></ion-toggle>
  </div>

  <!-- Информационное сообщение, если запрет уже установлен -->
  <!-- <div class="disable-parameter-changes-info" *ngIf="isEnabled" data-testid="disable-parameter-changes-info">
    <ion-text color="danger">
      <p class="info-text">
        <ion-icon name="lock-closed-outline"></ion-icon>
        Запрет на изменение параметров установлен. Все настройки ограничений недоступны. Снятие возможно только в отделении банка.
      </p>
    </ion-text>
  </div> -->

  <!-- Предупреждение перед установкой -->
  <!-- <div class="disable-parameter-changes-warning" *ngIf="!isEnabled" data-testid="disable-parameter-changes-warning">
    <ion-text color="warning">
      <p class="warning-text">
        <ion-icon name="warning-outline"></ion-icon>
        После установки этого запрета вы не сможете изменять никакие параметры счета через мобильное приложение
      </p>
    </ion-text>
  </div> -->
<!-- </div> -->
